// import _ from 'lodash';

class TranslateService {

  backendMessages = new Map();

  // operators = new Map();
  operators = new Map([
    // ["CONTAINS", "Contains"],
    // ["EQUALS", "Equals"],
    // ["EQUALS_NOT", "Equals not"],
    // ["IS_EMPTY", "is empty"],
    // ["IS_NOT_EMPTY", "is not empty"],
    // ["STARTS_WITH", "Starts with"],
    // ["ENDS_WITH", "Ends with"],
    // ["BOOLEAN", "Yes/No"],
    // ["GREATER_THAN", "Greater than"],
    // ["LESS_THAN", "Less than"],
  ]);

  fields = new Map([
    // ["TYPE_OF_RIGHTS", "Type of Rights"],
    // ["LICENCE_TERRITORIES", "Licence territories"],
    // ["EXCLUSIVE", "Exclusive"],
    // ["TIME_SPAN", "From/To"],
    // ["MIN_DURATION", "Duration"]
  ]);

  messages = [

    //Buttons
    {key: "button.search.reset", value: "Reset Search"},
    {key: "button.search.save", value: "Save Search"},
    {key: "button.add.condition", value: "Add Condition"},
    {key: "button.add.trafficlight", value: "Add Trafficlight"},
    {key: "button.search", value: "Search"},
    {key: "button.cancel", value: "Cancel"},
    {key: "button.save", value: "Save"},
    {key: "button.clone.trafficlight", value: "Clone Trafficlight"},
    {key: "button.remove.trafficlight", value: "Remove Trafficlight"},
    {key: "button.remove", value: "Remove"},
    {key: "button.replace.search", value: "Replace Search"},
    {key: "button.delete", value: "Delete"},
    {key: "button.load.profile", value: "Load Profile"},
    {key: "button.new.profile", value: "New Profile"},
    {key: "button.export", value: "Export"},
    {key: "button.create.offer", value: "Create Offer"},
    {key: "button.send.offer", value: "Send offer to mediafusion"},
    {key: "button.cancel.offer", value: "Cancel offer"},
    {key: "button.add.basket", value: "Add titles from basket"},
    {key: "button.save.offer", value: "Save changes"},
    {key: "button.create.export.profile", value: "Create Export Profile"},
    {key: "button.apply", value: "Apply"},
    {key: "button.clear", value: "Clear"},
    {key: "button.Okey", value: "Okey"},
    {key: "button.close", value: "Close"},
    {key: "button.anmelden", value: "Sign in"},
    {key: "button.back", value: "Back to Search"},

    //Tabs
    {key: "tab.header.search", value: "Search"},
    {key: "tab.header.Profile", value: "Profile"},
    {key: "tab.header.export", value: "Export"},
    {key: "picklist.tab.multiavail", value: "Multiavail"},

    //Header
    {key: "filter.caption", value: "Filter"},
    {key: "trafficLight.caption", value: "Traffic Lights"},
    {key: "header.selected", value: "Selected"},
    {key: "header.available", value: "Available"},
    {key: "header.create.new.Profile", value: "Create New Profile"},
    {key: "header.basket", value: "Basket"},
    {key: "header.type.of.rights", value: "Type of Rights"},
    {key: "header.territory", value: "Territory"},
    {key: "header.exclusive", value: "Exclusive"},
    {key: "header.option", value: "Option"},
    {key: "header.recent.offers", value: "Recent Offers"},
    {key: "header.time.windows", value: "Time Windows"},
    {key: "header.traffic.lights", value: "Traffic Lights"},
    {key: "header.save.Profile", value: "Save Profile"},
    {key: "header.type", value: "Type"},
    {key: "header.number", value: "Number"},
    {key: "header.partner", value: "Partner"},
    {key: "header.client", value: "Client"},
    {key: "header.State", value: "State"},
    {key: "header.start", value: "Start"},
    {key: "header.end", value: "End"},
    {key: "header.delete.confirmation", value: "Delete Confirmation"},
    {key: "picklist.header.profile.wizard", value: "Profile Wizard"},
    {key: "header.label", value: "Label"},

    //placeholder
    {key: "placeholder.no", value: "no"},
    {key: "placeholder.profile.name", value: "Profile name"},
    {key: "placeholder.no.filter", value: "No filter"},
    {key: "placeholder.new.profilename", value: "New profile name"},

    //Labels and Dialogs
    {key: "Export.Profile", value: "Export Profile"},
    {key: "label.offerDate", value: "Offer Date"},
    {key: "label.offerTitle", value: "Offer Title"},
    {key: "create.offer", value: "Create new Offer"},
    {key: "edit.offer", value: "Edit Offer"},
    {key: "label.offerRemark", value: "Remark"},
    {key: "label.dealMaker", value: "Deal Maker"},
    {key: "label.offerPartner", value: "Offer Partner"},
    {key: "label.contactPerson", value: "Contact Person"},
    {key: "choose.contact", value: "Choose contact person"},
    {key: "select.territories", value: "Select Territories"},
    {key: "select.type.of.rights", value: "Select Type of Rights"},
    {key: "no.records", value: "No Records"},
    {key: "selection.dialog.caption", value: "Make your selection"},
    {key: "profilename", value: "Profile name"},
    {key: "label.remove.profile", value: "Remove Profile"},
    {key: "label.save.profile", value: "Save Profile"},
    {key: "export.profiles", value: "Export Profiles"},
    {key: "would.you.delete.the.profile", value: "Would you delete the Profile: "},
    {key: "saved.display.profiles", value: "Saved display profiles"},
    {key: "saved.searchprofiles", value: "Saved search profiles"},
    {key: "dynamicTreeSelect.header", value: "Select"}


  ]

  messageSource = undefined;


  translateOperator(operator) {
    return this.translateMessage(operator);
  }

  fillMessageSource() {
    this.messageSource = new Map();

    for (let m of this.messages) {
      this.messageSource.set(m.key, m.value);
    }
  }

  addToMessageSource(messages) {
    if (this.messageSource === undefined) {
      this.messageSource = new Map();
    }

    for (let key in messages) {
      this.messageSource.set(key, messages[key]);
    }
  }

  translateMessage(messageKey) {
    if (this.messageSource === undefined) {
      this.fillMessageSource();
    }

    if (this.messageSource.has(messageKey)) {
      return this.messageSource.get(messageKey);
    } else {
      console.log("Fallback message: " + messageKey);
      return messageKey;
    }
  }

}

export default new TranslateService();
